<template>
  <v-app>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>


    <!--App Bar desktop -->
    <template>
      <!-- menu lateral -->      
      <v-navigation-drawer
        class="d-print-none"
        :clipped="$vuetify.breakpoint.lgAndUp"
        :expand-on-hover="miniMenu"
        :mini-variant="miniMenu"
        v-model="showMenu"
        v-if="showSideMenu"
        app
        color="#243fa0"
        dark
      >
        <Menu :menuItens="menuItens" />
      </v-navigation-drawer>

      <!--Header-->
      <v-app-bar
        class="d-print-none"
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="white"
        light
      >
        <v-app-bar-nav-icon @click.stop="handleMenu()" />

        <router-link to="/" class="mt-3">
          <img src="@/assets/logo-embarquemaisseguro.svg" alt="Embarque Seguro" class="mb-2 app-logo"/>
        </router-link>

        <v-spacer />

        <span class="d-none d-sm-block">
          <v-menu left :offset-y="true">
            <template v-slot:activator="{ on }">
              <v-btn
                text
                v-on="on"
                class="subtitle-1 text-capitalize font-weight-light"
              >
                {{ currentLanguage.name }}
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group v-model="currentLanguageIndex">
                <v-list-item
                  v-for="(item, index) in languages"
                  :key="index"
                  @click="clickChangeLanguage(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </span>

        <v-menu bottom left :offset-y="true" :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on" class="subtitle-1 text-capitalize font-weight-light">
              <span>{{ userName | truncate(15, "...") }}</span>
              <v-icon right>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list nav dense>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>{{ $t("account") }}</v-list-item-title>
                <v-list-item-subtitle>{{ userName }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>

            <v-list-group no-action>
              <template v-slot:activator>
                <v-list-item-title>{{ $t('languages')}}</v-list-item-title>
              </template>
              <v-list-item :input-value="currentLanguageIndex == index"
                v-for="(item, index) in languages"
                :key="index"
                @click="clickChangeLanguage(item)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-divider></v-divider>          

            <v-list-item link @click="myAccount()">
              <v-list-item-icon class="mx-1">
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("myAccount") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="logout()">
              <v-list-item-icon class="mx-1">
                <v-icon>mdi-exit-to-app</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("exit") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
    </template>
    <!--Fim app Bar desktop-->    

    <v-main class="grey lighten-4">
      <v-container fluid v-if="!loading">
        <UserWithoutFunctionality v-if="userWithoutFunctionality" />
        <UserRestrictedWithoutAirportAirline v-else-if="restrictUserWithoutAirportOrAirline" />
        <router-view v-else @changeAlertCount="changeAlertCount" @setTabsComp="setTabsComp"></router-view>
      </v-container>
      <v-container fluid v-else>
        <!-- Conteúdo em branco placeholder enquanto as permissões do usuário são checadas -->
      </v-container>
    </v-main>

    <Footer/>
  </v-app>
</template>

<script>
import Footer from "@/layouts/Footer.vue";
import userTokenHelper from "@/helpers/UserTokenHelper.js";
import GovBrService from "@/services/GovBrService.js";
import { LanguageMixin } from "@/mixins/LanguageMixin.js";
import { AdminMenuMixin } from "@/mixins/AdminMenuMixin.js";
import UserService from "@/services/UserService.js";
import UserWithoutFunctionality from "@/components/UserWithoutFunctionality.vue";
import UserRestrictedWithoutAirportAirline from "@/components/UserRestrictedWithoutAirportAirline.vue";
import Menu from "@/layouts/Menu.vue";

export default {
  mixins: [LanguageMixin, AdminMenuMixin ],
  components: { Footer, UserWithoutFunctionality, UserRestrictedWithoutAirportAirline,Menu },

  data: () => ({
    alerts : null,
    alertCount: 0,
    user: null,
    userWithoutFunctionality: true,
    restrictUserWithoutAirportOrAirline: true,
    loading: false,
    overlay: false,
    miniMenu: null,
    showMenu: null,
    languages: [
      { code: "pt", name: "Português" },
      // { code: "es", name: "Español" },
      { code: "en", name: "English" },
    ],
    currentLanguage: {},
    currentLanguageIndex: 0,
    currentTabsComponent: null,
    currentTabsRoute: null
  }),

  async created() {
    this.user = userTokenHelper.getUser();
    this.userWithoutFunctionality = this.menuItens.length == 1;
    const currentLanguageCode = this.getCurrentLanguageCode();
    this.changeLanguage(currentLanguageCode);
    this.miniMenu = localStorage.miniMenu == "true";
    this.loading = true;
    try {
      await this.checkRestricUserPermissions();
    } catch (e) {
      console.warn('Error getting current user info and permissions: ', e);
    } finally {
      this.loading = false;
    }
  },
  watch : {
    $route(val) {
      if (!val.matched.includes(this.currentTabsRoute)) {
        this.currentTabsComponent = null;
        this.currentTabsRoute = null;
      }
    }
  },
  methods: {
    async navigateToAlerts() {
      let url = {
        name: "alerts",
      };
      await this.$router.push(url);
    },
    
    /**
     * @languageCode: ex: pt
     */
    changeLanguage(languageCode) {
      this.configureLanguage(languageCode);

      this.currentLanguage = this.getLanguageByCode(languageCode);
      this.currentLanguageIndex = this.languages.indexOf(this.currentLanguage);
    },
    getLanguageByCode(languageCode) {
      const language = this.languages.filter((l) => l.code == languageCode);
      return language[0];
    },
    clickChangeLanguage(item) {
      this.changeLanguage(item.code);
      localStorage.lang = item.code;
    },
    handleMenu() {
      if (this.$vuetify.breakpoint.mobile) {
        this.showMenu = true;
        this.miniMenu = false;
      } else {
        this.miniMenu = !this.miniMenu;
        localStorage.miniMenu = this.miniMenu;
      }
    },
    logout() {
      GovBrService.logout().then(
        (r) => {
          userTokenHelper.removeUserToken();
          this.overlay = true;
          window.location = r.data;
        },
        () => {}
      );
    },
    myAccount() {
      GovBrService.myAccount().then(
        (r) => {
          window.open(r.data);
        },
        () => {}
      );
    },
    changeAlertCount(count) {
      this.alertCount = count;
    },
    setTabsComp(tabs) {
      this.currentTabsComponent = tabs.component;
      this.currentTabsRoute = tabs.route;
    },
    async checkRestricUserPermissions() {
      if (this.user.groups.length < 1) {
        return
      }

      const r = await UserService.currentUser();
      const org = r.data.organization;
      if (org.organizationType !== 'AIRPORT_OPERATOR' && 
          org.organizationType !== 'INTEGRATOR' && 
          org.organizationType !== 'AIRLINE') {
        this.restrictUserWithoutAirportOrAirline = false;
        return;
      }

      if (org.organizationType === 'AIRPORT_OPERATOR' && org.airports.length > 0) {
        this.restrictUserWithoutAirportOrAirline = false;
        return;
      }

      if (org.organizationType === 'INTEGRATOR' && org.airports.length > 0) {
        this.restrictUserWithoutAirportOrAirline = false;
        return;
      }

      if (org.organizationType === 'AIRLINE' && org.airlines.length > 0) {
        this.restrictUserWithoutAirportOrAirline = false;
        return;
      }      
    },
  },
  computed: {
    showSideMenu() {
      return !this.userWithoutFunctionality && !this.restrictUserWithoutAirportOrAirline;
    },
    menuItens() {
      return this.buildMenu(this.user);
    },
    userName() {
      return userTokenHelper.getUserName();
    },
    userInitials() {
      let userName = this.userName;
      let words = userName.split(' ');
      let initials = words.map(word => word.substring(0, 1).toUpperCase());
      return initials.join('');
    },
    currentRouteText() {
      return this.$route.meta["text"] ?? "";
    },
  },
  filters: {
    truncate: function(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
};
</script>

<style lang="scss">

.app-logo {
  width: 170px;
}

@media screen and (max-width:500px) {
  .app-logo {
    width: 150px;
  }
}

@media print {
  .v-main {
    padding: 0 !important;
  }
}

.active-menu-item {
  color: white !important;
  background: rgba(255, 255, 255, 0.1);
}
.account-menu-link {
  text-transform: none !important;
}

</style>
